import React, { useEffect, useState, useRef } from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

function ListGames({ games, selectFromList, teamID }) {
  console.log(teamID);
  let win, loss, tie;
  if (teamID) {
    games.map((game) => {
      if (game.win === "Win") {
        win = (win || 0) + 1;
      }
      if (game.win === "Loss") {
        loss = (loss || 0) + 1;
      }
      if (game.win === "Tie") {
        tie = (tie || 0) + 1;
      }
    });
  }
  return (
    <div>
      <div style={{ color: "white", fontSize: "xx-large", backgroundColor: "#fe5000", marginTop: 2 }}>
        Team Record: {teamID && `${win || 0} - ${loss || 0} - ${tie || 0}`}
      </div>
      <table class="table table-striped table-hover" style={{ width: "100%", fontSize: "0.8rem" }}>
        <thead>
          <tr>
            <th scope="col">H/A</th>
            <th scope="col">Date</th>
            <th scope="col">Time</th>
            {typeof teamID == "undefined" || teamID == null ? <th scope="col">Team</th> : null}
            <th scope="col">Opponent</th>
            <th scope="col">Event Title</th>
            <th scope="col">Location</th>
            <th scope="col">Departure Time</th>
            <th scope="col">Score</th>
            <th scope="col">Info</th>
          </tr>
        </thead>
        <tbody class="table-hover">
          {console.log(games)}
          {games.length == 0 ? (
            <tr style={{ backgroundColor: "white" }}>
              <td colspan="100" style={{ backgrundColor: "white", padding: 0 }}>
                <div
                  style={{
                    padding: 0,
                    backgroundColor: "white",

                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div class="spinner-border text-warning" style={{ margin: 5 }} role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <br></br>
                  <span>Loading games...</span>
                </div>
              </td>
            </tr>
          ) : (
            games.map((game, index) => (
              <tr
                key={index}
                className={game.isCancelled ? "table-danger" : game.isRescheduled ? "table-warning" : ""}
                onClick={() =>
                  selectFromList({
                    actualTitle: game.actualTitle,
                    score: game.score,
                    win: game.win,
                    title: game.title,
                    team: game.team,
                    isCancelled: game.isCancelled,
                    isRescheduled: game.isRescheduled,
                    away: game.away,
                    address: game.address,
                    opponent: game.opponent,
                    dismissal: game.dismissal,
                    departure: game.departure,
                    transportation: game.transportation,
                    start: game.start,
                    end: game.end,
                    description: game.description,
                    notes: game.notes,
                    location: game.location,
                    time: game.time,
                    allDay: game.allDay,
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <td class="text-nowrap">
                  {game.isCancelled ? (
                    <i style={{ fontSize: "1em", color: "red" }} class="fa-solid fa-triangle-exclamation"></i>
                  ) : game.isRescheduled ? (
                    <i style={{ fontSize: "1em", color: "grey" }} class="fa-solid fa-clock-rotate-left"></i>
                  ) : game.away ? (
                    "Away"
                  ) : (
                    "Home"
                  )}
                </td>
                <td class="text-nowrap">{game.date.substring(0, 10)}</td>
                <td class="text-nowrap">{game.time || "TBA"}</td>
                {typeof teamID == "undefined" || teamID == null ? <td class="text-nowrap">{game.team}</td> : null}
                <td class="text-nowrap">{game.opponent}</td>

                <td class="text-nowrap">{game.actualTitle}</td>
                <td class="text-nowrap" class="text-nowrap">
                  {game.location}
                </td>
                <td class="text-nowrap">{game.departure}</td>
                <td class="text-nowrap">
                  {game.isCancelled && "CANCELLED"}
                  {game.isRescheduled && "RESCHEDULED"}
                  {game.score}{" "}
                  {game.win === "Win" ? (
                    <span style={{ color: "green" }}>
                      <b>(W)</b>
                    </span>
                  ) : game.win === "Loss" ? (
                    <span style={{ color: "red" }}>
                      <b>(L)</b>
                    </span>
                  ) : game.win === "Tie" ? (
                    <span style={{ color: "black" }}>
                      <b>Tie</b>
                    </span>
                  ) : (
                    ""
                  )}
                </td>
                <td class="text-nowrap">
                  <i style={{ fontSize: "1em", color: "#fe5000" }} class="fa-solid fa-circle-info"></i>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
export default ListGames;
